const BlogReducer = (blog = {}, action) => {
  switch (action.type) {
    case 'LOAD_SINGLE_MESSAGE':
      return (blog = action.payload);

    case 'REPLIES':
      return { ...blog, post: action.payload };

    case 'DELETE_REPLY':
      return { ...blog, post: { ...blog.post, comments: action.payload } };

    case 'EDIT_REPLY':
      return { ...blog, post: { ...blog.post, comments: action.payload } };

    default:
      return blog;
  }
};

export default BlogReducer;
